import * as React from 'react';
import styled from 'styled-components';

interface HiddenAutofillInputProps {
  username: string;
}

/* Input for autofill to populate username */
const HiddenAutofillInput: React.FC<HiddenAutofillInputProps> = ({ username }) => (
  <HiddenInput
    id="username"
    autoComplete="username"
    // tslint:disable-next-line:no-empty
    onChange={() => {}}
    data-id="username-hidden"
    value={username}
  />
);

// use display none to hide as hidden input
// does not trigger autocomplete
const HiddenInput = styled.input`
  display: none;
`;

export { HiddenAutofillInput };
